import { Reader } from "../Reader";
import { RecordCache } from "./RecordCache";
import { Time } from "@/lib/Time";
import Vue from "vue";

export class RecordCacheReader extends Reader {
  _userId;
  _year;
  data = {};

  constructor({ userId } = {}) {
    super();
    if (userId == undefined) {
      throw Error("userId is required in RecordCacheReader");
    }
    this._userId = userId;
    this._year = `${Time.date.get(Time.date.getNow(), Time.unit.year)}`;
  }
  start() {
    let { p, done } = this._makeReadyPromise();

    this._setStatusRunning();
    this._firestore
      .collectionGroup(`recordCaches`)
      .where("userId", "==", this._userId)
      .where("recordCacheId", "==", this._year)
      .onSnapshot(
        querySnapshot => {
          Vue.set(this, "data", {});
          querySnapshot.forEach(doc => {
            let rc = new RecordCache(doc.ref.path);
            rc.updateData({ userId: this._userId });
            rc.updateData(doc.data());
            Vue.set(this.data, rc.getProjectId(), rc);
          });
          this._setStatusReady();
          done();
        },
        error => {
          console.error("RecordCacheReader Error: ", error);
        }
      );

    return p;
  }

  getByProjectId(projectId) {
    if (this.data[projectId] == undefined) {
      this.data[projectId] = this.create(projectId, this._year);
    }
    return this.data[projectId];
  }

  create(projectId, year) {
    let p = new RecordCache(
      `users/${this._userId}/projects/${projectId}/recordCaches/${year}`
    );
    p.updateData({
      userId: this._userId,
      recordCacheId: year,
      projectId
    });
    return p;
  }
}
